import type DrawerStacker from './drawer_stacker';

// singleton module for managing the drawer_stacker instance
let drawerStacker: DrawerStacker | undefined;

export const getDrawerStacker = () => {
  return drawerStacker;
};

export const setDrawerStacker = (newDrawerStacker: DrawerStacker) => {
  drawerStacker = newDrawerStacker;
};
